import { render, staticRenderFns } from "./PropertyTypeIcon.vue?vue&type=template&id=219f6fa8"
import script from "./PropertyTypeIcon.vue?vue&type=script&lang=js"
export * from "./PropertyTypeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports